import React, {useEffect} from "react";
import Pagination from "react-bootstrap/Pagination";
import {useDispatch, useSelector} from "react-redux";
import {getAppConfig, setPagination} from "../../redux/slices/appconfigSlice";
import "./style.scss";
import PropTypes from "prop-types";
import useWindowDimensions from "../../utils/getWindowDimensions";
import {getPager} from "../../helpers/common";
import useTranslationCustom from "../../i18n/customHook/useTranslation";

const PaginationSection = ({_setPage, page}) => {
    const {T} = useTranslationCustom();
    const dispatch = useDispatch();
    const {width} = useWindowDimensions();
    const appconfig = useSelector(getAppConfig);
    const metaDataCount = appconfig?.metaDataCount;

    useEffect(() => {
        // Recompute whenever anything the pager is derived from changes.
        // Previously this depended on [width] alone, so moving page or running a
        // search with a different result count left the page window stale.
        const maxPages = width < 768 ? 5 : 10;
        dispatch(setPagination(getPager(metaDataCount, page, 10, maxPages)));
    }, [width, page, metaDataCount, dispatch]);

    return (
        <>
            {appconfig.offers?.length &&
            appconfig.pagination?.startPage !== appconfig.pagination?.endPage ? (
                <Pagination>
                    {page > 1 && (
                        <Pagination.Prev onClick={() => _setPage(page - 1)}>
                            <span className="next-prev">{T("Buttons:Prev")}</span>
                        </Pagination.Prev>
                    )}
                    {appconfig.pagination?.pages?.map((pageNumber, index) => {
                        return (
                            <Pagination.Item
                                key={index}
                                active={pageNumber === page}
                                onClick={() => _setPage(pageNumber)}
                            >
                                {pageNumber}
                            </Pagination.Item>
                        );
                    })}
                    {page < appconfig.pagination?.endPage && (
                        <Pagination.Next onClick={() => _setPage(page + 1)}>
                            <span className="next-prev">{T("Buttons:Next")}</span>
                        </Pagination.Next>
                    )}
                </Pagination>
            ) : (
                ""
            )}
        </>
    );
};

PaginationSection.propTypes = {
    _setPage: PropTypes.func,
    page: PropTypes.number,
};

export default PaginationSection;
